import ERC20 from "../abi/ERC20.json";
import { getAddress } from "./get-address";
import { ethers, BigNumber } from "ethers";
import StakeABI from '../abi/StakeABI.json';

export const stake = async (_amount, _referrer) => {
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const { chainId } = await provider.getNetwork();
        const addresses = getAddress(chainId);

        if (addresses) {
            const signer = provider.getSigner();
            const stakeContract = new ethers.Contract(
                addresses.stake_address,
                StakeABI.abi,
                signer
            );

            const bigNum = BigNumber.from(_amount.toString()).mul(BigNumber.from(10).pow(18));
            const GAS = "5";
            let gasPrice = await provider.getGasPrice();
            const convertGas = ethers.utils.parseUnits(GAS, "gwei");
            gasPrice = gasPrice.add(convertGas);
            const fee = await stakeContract.stakeFee();
            // Send the transaction  
            const txn = await stakeContract.stake(bigNum, _referrer, {
                value: fee,
                gasPrice: gasPrice,
            });

            const receipt = await provider.waitForTransaction(txn.hash, 1, 60000);
            if (receipt && receipt.status === 1) {
                await new Promise((resolve) => setTimeout(resolve, 8000));
                return { success: true, message: "Transaction successful", hash: txn.hash };
            } else {
                // Transaction failed
                return { success: false, message: "Transaction failed", hash: txn.hash };
            }
        } else {
            return { success: false, message: "Wrong Network!" };
        }
    } catch (e) {
        console.error("Error during stake:", e);
        let errorMessage = "An unknown error occurred";
        if (e.code === "ACTION_REJECTED") {
            errorMessage = "User rejected the transaction";
        } else if (e.message) {
            errorMessage = e.message.split("(")[0].trim();
        }

        return { success: false, message: errorMessage };
    }
};
